import { createSelector } from "reselect";

import groups from "./groups";

const users = {};

/**
 * Returns all users.
 * @param {Object} state
 * @returns {Object[]} users
 */
users.get = state => state.users.items;

/**
 * Returns uri of current user.
 * @param {Object} state
 * @returns {string} uri
 */
users.getCurrentUri = state => state.users.current;

/**
 * Returns filter term for users.
 * @param {Object} state
 * @returns {string} filterTerm
 */
users.getFilterTerm = state => state.users.filterTerm;

/**
 * Returns current user object.
 * @param {Object} state
 * @returns {Object[]} users
 */
users.getCurrent = createSelector(
  [users.getCurrentUri, users.get],
  (currentUserUri, users) => users.find(user => user.$uri === currentUserUri)
);

/**
 * Returns users filtered by users.filterTerm.
 * @param {Object} state
 * @returns {Object[]} users
 */
users.getFiltered = createSelector(
  [users.get, users.getFilterTerm],
  (users, filter) => {
    if (filter) {
      return users.filter(user => user.username.toLowerCase().includes(filter));
    }
    return users;
  }
);

/**
 * If currentGroup is defined, return users that are in that group,
 * otherwise return an empty list.
 * @param {Object} state
 * @returns {Object[]} users
 */
users.getByCurrentGroup = createSelector(
  [groups.getCurrent, users.get],
  (currentGroup, users) => {
    if (!currentGroup) {
      return [];
    }
    return users.filter(user => {
      const groups = user.groups.map(group => group.$ref);
      return groups.includes(currentGroup.$uri);
    });
  }
);

/**
 * Returns an error object for users.
 * @returns {(Object|null)} An object with an error and description or null.
 */
users.getError = state => {
  if (state.users.error) {
    return {
      description: state.users.errorDescription,
      error: state.users.error
    };
  }
  return null;
};

export default users;
